<template>
  <div class="row">
    <div class="col-lg-8 inline">
      <h4>
        <h2 style="display: inline">Analytics | &nbsp;</h2>
        Select Time:
        <el-select
          class="select-info tab select-width"
          placeholder="Single Select"
          v-model="selects.time"
          @change="getData()"
        >
          <el-option
            v-for="option in selects.times"
            class="select-info"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-4 style-date">
      <span class="demonstration">Select Date Range</span>
      <el-date-picker
        v-model="selects.date"
        type="daterange"
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        @change="getData()"
      ></el-date-picker>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col">
          <h4>
            Select Site:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.site"
              @change="getData()"
            >
              <el-option
                v-for="option in selects.sites"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <hr />
    </div>

    <div class="col-lg-4">
      <card type="card-chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Sulphur Dioxide (SO<sub>2</sub>)</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="so2.loaded"
            :chart-data="so2.chartData"
            :extra-options="so2.extraOptions"
            :gradient-colors="so2.gradientColors"
            :gradient-stops="so2.gradientStops"
            :height="245"
          ></bar-chart>
          <div class="d-flex justify-content-center spinner" v-if="!so2.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4">
      <card type="card-chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Nitrogen Oxide (No<sub>x</sub>)</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="no.loaded"
            :chart-data="no.chartData"
            :extra-options="no.extraOptions"
            :gradient-colors="no.gradientColors"
            :gradient-stops="no.gradientStops"
            :height="245"
          ></bar-chart>
          <div class="d-flex justify-content-center spinner" v-if="!no.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4">
      <card class="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Carbon Monoxide (CO)</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="co.loaded"
            :chart-data="co.chartData"
            :extra-options="co.extraOptions"
            :gradient-colors="co.gradientColors"
            :gradient-stops="co.gradientStops"
            :height="245"
          ></bar-chart>
          <div class="d-flex justify-content-center spinner" v-if="!co.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4 d-flex">
      <card type="card-chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Hydrogen Chloride (HCL)</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="hcl.loaded"
            :chart-data="hcl.chartData"
            :extra-options="hcl.extraOptions"
            :gradient-colors="hcl.gradientColors"
            :gradient-stops="hcl.gradientStops"
            :height="245"
          ></bar-chart>
          <div class="d-flex justify-content-center spinner" v-if="!hcl.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4 d-flex">
      <card type="card-chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Hydrogen Fluoride (HF)</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="hf.loaded"
            :chart-data="hf.chartData"
            :extra-options="hf.extraOptions"
            :gradient-colors="hf.gradientColors"
            :gradient-stops="hf.gradientStops"
            :height="245"
          ></bar-chart>
          <div class="d-flex justify-content-center spinner" v-if="!hf.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4 d-flex">
      <card class="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Non-methane Volatile Organic Compound (NMVOC)</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="nmvoc.loaded"
            :chart-data="nmvoc.chartData"
            :extra-options="nmvoc.extraOptions"
            :gradient-colors="nmvoc.gradientColors"
            :gradient-stops="nmvoc.gradientStops"
            :height="245"
          ></bar-chart>
          <div
            class="d-flex justify-content-center spinner"
            v-if="!nmvoc.loaded"
          >
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4">
      <card type="card-chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Percentage of Emission Oxygen (O<sub>2</sub>) gas</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="o2.loaded"
            :chart-data="o2.chartData"
            :extra-options="o2.extraOptions"
            :gradient-colors="o2.gradientColors"
            :gradient-stops="o2.gradientStops"
            :height="245"
          ></bar-chart>
          <div class="d-flex justify-content-center spinner" v-if="!o2.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4">
      <card type="card-chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Percentage of the Particles Opacity</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="opacity.loaded"
            :chart-data="opacity.chartData"
            :extra-options="opacity.extraOptions"
            :gradient-colors="opacity.gradientColors"
            :gradient-stops="opacity.gradientStops"
            :height="245"
          ></bar-chart>
          <div
            class="d-flex justify-content-center spinner"
            v-if="!opacity.loaded"
          >
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4">
      <card class="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Total Particulate Metal (TPM)</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="tpm.loaded"
            :chart-data="tpm.chartData"
            :extra-options="tpm.extraOptions"
            :gradient-colors="tpm.gradientColors"
            :gradient-stops="tpm.gradientStops"
            :height="245"
          ></bar-chart>
          <div class="d-flex justify-content-center spinner" v-if="!tpm.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import { Select, Option, DatePicker } from "element-ui";

import axios from "axios";
import moment from "moment";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import { time } from "d3";

export default {
  components: {
    LineChart,
    BarChart,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    Circle8,
  },
  data() {
    return {
      // Selecting interval data
      selects: {
        site: "",
        sites: [],
        time: "",
        times: [
         
          { value: "weekly", label: "Weekly" },
          { value: "monthly", label: "Monthly" },
          { value: "yearly", label: "Yearly" },
        ],
        date: "",
      },
      so2: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      no: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      co: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },
      hcl: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      hf: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      nmvoc: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      o2: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      opacity: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      tpm: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      // customer rating
      // rating: [],
      // punctuality
      // punctuality: [],
    };
  },
  methods: {
    getAllDataOnRange() {
      console.log(this.selects.date);
    },
    getSite() {
      this.selects.sites = [];

      this.$http.get(":9997/api/v1/setting/plant").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].PlantName,
              value: response[i].PlantID,
            };

            this.selects.sites.push(obj);
          }

          this.selects.time = this.selects.times[0].value;
          this.selects.date = [moment().startOf("w"), moment().endOf("w")];
          this.selects.site = this.selects.sites[0].value;

          this.getData();
        }
      });
    },
    async getData() {
      console.log(this.selects.time);
      console.log(this.selects.site);
      console.log(this.selects.date);

      let start = moment(this.selects.date[0]).format("YYYY-MM-DD");
      let end = moment(this.selects.date[1]).format("YYYY-MM-DD");
      // let start = "2022-06-12"
      // let end = "2022-06-13"
      console.log(start, end);

      this.$http
        .get(
          ":9997/api/v1/analytics/trend/" +
            this.selects.site +
            "?interval=" +
            this.selects.time +
            "&from=" +
            start +
            "&to=" +
            end
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            let timestamp = [];
            let so2 = [];
            let no = [];
            let co = [];
            let hcl = [];
            let hf = [];
            let nmvoc = [];
            let o2 = [];
            let opacity = [];
            let tpm = [];

            for (var i = 0; i < response.length; i++) {
              timestamp.push(response[i].Interval);
              so2.push((response[i].So2_avg).toFixed(2));
              no.push((response[i].No2_avg).toFixed(2));
              co.push((response[i].Co_avg).toFixed(2));
              hcl.push((response[i].Hcl_avg).toFixed(2));
              hf.push((response[i].Hf_avg).toFixed(2));
              nmvoc.push((response[i].Nvmoc_avg).toFixed(2));
              o2.push((response[i].O2_avg).toFixed(2));
              opacity.push(0)
              tpm.push((response[i].TOTAL_PM_avg).toFixed(2));
            }

            this.so2 = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "%Number of Pickup",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: so2,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };

            this.no = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "%Number of Pickup",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: no,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };

            this.co = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "%Number of Pickup",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: co,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };

            this.hcl = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "%Number of Pickup",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: hcl,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };

            this.hf = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "%Number of Pickup",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: hf,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };

            this.nmvoc = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "%Number of Pickup",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: nmvoc,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };

            this.o2 = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "%Number of Pickup",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: o2,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };

            this.opacity = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "%Number of Pickup",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: opacity,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };

            this.tpm = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "%Number of Pickup",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: tpm,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };
          }
        });
    },
  },
  created() {
    this.getSite();
    
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
}
hr {
  color: black;
  margin-top: 0%;
}
.select-width {
  max-width: 50%;
}
.spinner {
  margin: 12%;
}
</style>